import { ClipboardCheckIcon, DropletsIcon, FactoryIcon, LeafIcon, RecycleIcon, TreesIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fondamenti di Gestione Ambientale',
    summary: 'Ambiente, ecosistemi, cicli biogeochimici, servizi ecosistemici, impatto ambientale, modello DPSIR e impronta ecologica.',
    icon: LeafIcon,
  },
  {
    number: '2',
    title: 'Risorse Naturali: Acqua, Suolo, Aria ed Energia',
    summary: "Stock e flussi, risorsa idrica e bacini, falde, qualità dell'acqua, suolo e sue funzioni, aria ed energia.",
    icon: DropletsIcon,
  },
  {
    number: '3',
    title: "Inquinamento e Valutazione dell'Impatto Ambientale",
    summary: "Fonti e tipi di inquinanti, aria, acqua e suolo, microplastiche, depurazione e valutazione dell'impatto.",
    icon: FactoryIcon,
  },
  {
    number: '4',
    title: 'Rifiuti, Riciclo ed Economia Circolare',
    summary: 'Gerarchia dei rifiuti, spreco alimentare, raccolta differenziata, cicli del riciclo, compostaggio ed economia circolare.',
    icon: RecycleIcon,
  },
  {
    number: '5',
    title: 'Cambiamento Climatico, Biodiversità e Conservazione',
    summary: 'Effetto serra e gas serra, prove e impatti del cambiamento climatico, mitigazione e adattamento, biodiversità e conservazione.',
    icon: TreesIcon,
  },
  {
    number: '6',
    title: 'Sistemi di Gestione Ambientale e Sostenibilità',
    summary: 'SGA, ciclo PDCA, norma ISO 14001, politica e obiettivi ambientali, comunicazione e miglioramento continuo.',
    icon: ClipboardCheckIcon,
  },
];
